import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateCollectionRequest } from './update-collection-request';
import type { IUpdateCollectionResponse } from './update-collection-response';
import { updateCollectionResponseSchema } from './update-collection-response';

export async function updateCollectionApi({
  id,
  body,
}: IUpdateCollectionRequest): Promise<IValidatedResponse<IUpdateCollectionResponse>> {
  return putRequest<IUpdateCollectionResponse>({
    path: `/sys/collections/${id}`,
    body,
    schema: updateCollectionResponseSchema,
  });
}
